(function () {
    'use strict';

    angular.module('swif.interventions')
        .controller('TaskController', TaskController)
        .controller('TaskDetailsModalController', TaskDetailsModalController);



    function TaskController(
        $scope, $sce, $timeout, swif, swifInterventionsService, achats,
         swifOpenbaseCompanyService, swifRecurrenceService, openbase, gettextCatalog, $q,
        goNetEndpointApi
    ) {
        'ngInject';

        var moduleInter = swifInterventionsService;
        console.log('init TaskController');
        $scope.loading = {
            tasks: {}
        };
        $scope.model._type = 'task';
        $scope.selected = {};
        $scope.consumableIdToName = {};
        $scope.state = {};
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;
        // Keep trace of project_id before any change
        $scope.model.original_project_id = angular.copy($scope.model.project_id);
        var user = swif.user.getAuthenticatedUserData();
        if ($scope.model.create_uid) {
            $scope.is_creator = $scope.model.create_uid[0] === user.id;
        } else {
            $scope.is_creator = true;
        }
        if($scope.model.site1){
            let filters = { 'fields': ['name', 'owners', 'city', 'street', 'parcel_matricule', 'cadastral_parcel']};
            swif.data.get('site', $scope.model.site1[0], filters).then(site => {
                $scope.model.siteDataDetails = site
            })
        }


        $scope.isUserPartner = _.contains(user.access_rights, 'PRES');
        if ($scope.isUserPartner) {
            swif.data.get('partner', user.partner_id[0]).then(function (partner) {
                if (partner.technical_service_id && !$scope.model.service_id) {
                    $scope.model.service_id = partner.technical_service_id;
                }
                if (partner.technical_site_id && !$scope.model.site1) {
                    $scope.model.site1 = partner.technical_site_id;
                }
            });
            $scope.partnerValue = user.partner_id;
        }

        if ($scope.action.id == 'copy' && $scope.model.user_id) {
            // Pop name from user_id for select_multiple usage
            $scope.model.user_id.pop()
        }

        // Set default state
        if (!$scope.model.state) {
            $scope.model.state = 'open';
        }

        $scope.siteOnTaskFeature = swif.settings.app.features.siteOnTask;
        $scope.domeccoActivated = swif.settings.app.features.domeccoActivated;
        $scope.equipmentMovementFeature = swif.settings.app.features.equipmentMovement;
        $scope.userManageEquipmentMovement = user.can_manage_equipment_move;
        // $scope.project_type = moduleInter.intervention.getProjectType();
        $scope.state.done = ($scope.model.state === 'done');
        swifOpenbaseCompanyService.getGlobalSettings().then(function(company) {
            $scope.taskRangeEnabled = company.task_range_enable;
            $scope.taskNotify = company.task_notify;
            $scope.state.advanced_mode = company.add_task_window_advanced_mode;
            $scope.state.patrimony_tab_enabled = company.task_patrimony_tab_enable;
            $scope.state.patrimony_tab_required = company.task_patrimony_tab_required;
            $scope.task_purchase_order_default_value = company.task_purchase_order_default_value;
            $scope.customerInfosTab = company.customer_info_tab_enable;
            $scope.model.is_canadian = company.is_canadian;
            if($scope.model.is_canadian){
                goNetEndpointApi.getGoNetToken()
            }
            if (company.task_notify === false) {
                $scope.model.notify = false;
            }
            if ($scope.model.notify === undefined){
                $scope.model.notify = company.task_notify_default_value;
            }
            if ($scope.action.id === 'done' || $scope.action.id === 'notfinished') {
                if ($scope.state.patrimony_tab_enabled) {
                    $scope.loadReferentielItems();
                    if ($scope.state.patrimony_tab_required) {
                        $scope.action.hiddenTitle = $scope.action.title;
                        $scope.action.title = "Update referentiel";
                        $scope.form.$waitAction = true;
                    }
                }
            }
            if (!$scope.model.planned_hours) {
                $scope.model.planned_hours = company.task_default_hours;
            }
            if ($scope.state.done) {
                if ($scope.model.effective_hours) {
                    $scope.model.report_hours = $scope.model.effective_hours;
                } else {
                    $scope.model.report_hours = company.task_default_report_hours;
                }
            }
        });

        $scope.consumableRequestDone = ['in_progress','done', 'in_except'].includes($scope.model.consumable_request_state)
        // compute consumable_request (cr) visibility
        var modules = swif.module.modules;
        var crFeature = swif.settings.app.features.consumable_requests;
        var crPerm = achats.common.rights.getPermissions().consumable_request;
        $scope.crActive = modules.openstc_achat_stock && crFeature && (crPerm.claimer || crPerm.manager);
        $scope.user = swif.user.getAuthenticatedUserData();
        $scope.openstc_achat_stock_active = modules.openstc_achat_stock;
        $scope.team_splited = false;
        $scope.toggleSplitTeam = toggleSplitTeam;
        $scope.setCurrentTr = setCurrentTr;
        $scope.setCurrentTmpl = setCurrentTmpl;
        $scope.deleteTask = deleteTask;
        $scope.addNewAgentModel = {};
        $scope.addNewAgent = addNewAgent;
        $scope.loadAskedConsumables = loadAskedConsumables;
        $scope.referentialChecked = referentialChecked;
        $scope.addTasksFromRange = addTasksFromRange;
        $scope.moveTemplate = moveTemplate;
        $scope.removeTemplate = removeTemplate;
        $scope.samePeopleForNext = samePeopleForNext;
        $scope.sameDateForNext = sameDateForNext;
        $scope.calculateRangeHours = calculateRangeHours;
        $scope.onCustomerPartnerChange = onCustomerPartnerChange;
        $scope.onCustomerPartnerAddressChange = onCustomerPartnerAddressChange;
        $scope.deleteCustomer = deleteCustomer;
        $scope.consumable_choices = [];
        $scope.state_options = {
            "site": [],
            "equipment": []
        };
        $scope.referentiel_items = {
            "site": {},
            "equipment": {}
        };
        $scope.model._referentiel_items = [];

        $scope.resizeModal = function(action) {
            if (action === "up") {
                $('.modal-dialog').addClass('modal-lg');
            } else if (action === "down") {
                $('.modal-dialog').removeClass('modal-lg');
            }
        };
        // TG-2855 : eventually add into "ConsumableTabSelect"
        $scope.consumableRequestDone = ['in_progress','done', 'in_except'].includes($scope.model.consumable_request_state)

        if ($scope.equipmentMovementFeature) {
            $scope.model.equipment_movement_type = $scope.model.equipment_movement_type ? $scope.model.equipment_movement_type : 'assignment';
        }

        // state labels displayed near each consumable action
        var ask_prod_state = $scope.model.consumable_request_state;
        if (ask_prod_state) {
            $scope.askProdState = swif.settings.getContentType('openstc_ask_prod').states[ask_prod_state];
            $scope.askProdLabelclass = `label-${$scope.askProdState.labelclass}`;
        }
        if ($scope.model.purchase_order_ask_fields){
            var purchase_order_ask_state = $scope.model.purchase_order_ask_fields.state;
            if (purchase_order_ask_state) {
                $scope.POAskState = swif.settings.getContentType('quotation').states[purchase_order_ask_state];
                $scope.POAskLabelclass = `label-${$scope.POAskState.labelclass}`;
            }
        }
        if ($scope.model.purchase_order_fields) {
            var purchase_order_state = $scope.model.purchase_order_fields.state;
            if (purchase_order_state) {
                $scope.POState = swif.settings.getContentType('purchase_order').states[purchase_order_state];
                $scope.POLabelclass = `label-${$scope.POState.labelclass}`;
            }
        }

        $scope.onChangeFakeProductPurchase = function (purchase, product) {
            achats.purchase.addLine(purchase, product);
            _.forEach(purchase.lines, function (line) {
                line.taxChoices = achats.common.tax.lastData;
            });
            $scope.fakes.purchase_order_ids = false;
        };

        $scope.addFakeProduct = function (model, product) {
            achats.quotation.addProductInPOAsk(model, product);
            $scope.fakes.product_id = false;
        };

        $scope.consumablesTabSelect = function () {
            $scope.resizeModal('up');
            //from purchase_order modal initialization
            $scope.fakes = {
                purchase_order_ids: false,
                purchase_order_ask_ids: false
            };
            if (!$scope.model.purchase_order_fields) {
                $scope.model.purchase_order_fields = {lines : []};
            }
            if (!$scope.model.purchase_order_ask_fields) {
                $scope.model.purchase_order_ask_fields = {products : []};
            }
            swifOpenbaseCompanyService.getGlobalSettingsPurchases().then(function(company) {
                $scope.globalSettingsPurchases = company;
                if(!$scope.model.purchase_order_fields.warehouse_id){
                    $scope.model.purchase_order_fields.warehouse_id = company.default_warehouse_id;
                }
                if(!$scope.model.purchase_order_fields.account_analytic_id){
                    $scope.model.purchase_order_fields.account_analytic_id = company.default_budget_id;
                }

                if($scope.globalSettingsPurchases.enable_purchase_order_ask === false && $scope.globalSettingsPurchases.enable_purchase_order === false){
                    $scope.isOpen = true;
                }
                else{
                    $scope.isOpen = false;
                }
            });

            $scope.achats_filters = achats.purchase.getFilters();
            $scope.achats_filters.product_id.fields = ['id', 'name', 'complete_name', 'is_stock'];
            achats.common.tax.fetchChoices().then(function () {
                _.forEach($scope.model.purchase_order_fields.lines, function (line) {
                    line.taxChoices = achats.common.tax.lastData;
                });
                achats.purchase.computeLines($scope.model.purchase_order_fields);
                achats.purchase.computeBudgets($scope.model.purchase_order_fields);
            });
        }

        function _prepareItem(item) {
            var state = item.state === false ? "false" : item.state;
            var state_label = "";
            angular.forEach($scope.state_options[item._type], function(option) {
                var val = option.id === false ? "false": option.id;
                if (state === val) {
                    state_label = option.name;
                    return;
                }
            });
            // @TODO - @FIXME Yes, very very ugly hack to use
            // swif-widget-select-one. However, we can't easily use a raw
            // <select> input with ng-options due to `false` value too :/
            // To limit the side effect, we set a temporary attribute.
            item.state_map = [state, state_label]

            var service_ids = null;
            if (item._type === 'equipment') {
                service_ids = item.maintenance_service_ids;
            } else {
                service_ids = item.service_ids;
            }
            // To have permission, there is no maintenance service or one of it is the same as the task.
            item.show_actions = false;
            if (service_ids.length === 0 || service_ids.indexOf($scope.model.service_id[0]) > -1) {
                item.show_actions = true;
            }
        }

        /**
         * Recursive function to build a recursive map of parent and children
         * tree.
         */
        function _buildItemTree(parent_item, tree, fields) {
            var ret = $q.defer();

            var filter = fields.length > 0 ? {fields: fields} : {};
            swif.data.addFilter(filter, '|');
            swif.data.addFilter(filter, '&');
            swif.data.addFilter(filter, 'active', '=', true);
            swif.data.addFilter(filter, 'active', '=', false);

            if (parent_item._type === 'site') {
                swif.data.addFilter(filter, 'site_parent_id', '=', parent_item.id);
            } else {
                swif.data.addFilter(filter, 'parent_id', '=', parent_item.id);
            }
            swif.data.get(parent_item._type, undefined, filter).then(children => {
                var deferred = [];

                angular.forEach(children, function(child) {
                    _prepareItem(child);

                    tree[child.id] = {
                        'item': child,
                        'children': {}
                    }

                    deferred.push(_buildItemTree(child, tree[child.id]['children'], fields));
                });

                $q.all(deferred).then(function() {
                    ret.resolve(children);
                });
            });

            return ret.promise;
        }

        /**
         * In fact, just fetch the element with ID and returns it.
         */
        function _fetchItemRootTree(item_type, item_id, fields) {
            var ret = $q.defer();

            var filter = fields.length > 0 ? {fields: fields} : {};
            swif.data.addFilter(filter, '|');
            swif.data.addFilter(filter, '&');
            swif.data.addFilter(filter, 'active', '=', true);
            swif.data.addFilter(filter, 'active', '=', false);
            swif.data.addFilter(filter, 'id', '=', item_id);
            swif.data.get(item_type, undefined, filter).then(items => {
                var root_item = null;

                if (items.length > 0) {
                    root_item = items[0];
                    _prepareItem(root_item);
                }

                ret.resolve(root_item);
            });

            return ret.promise;
        }

        /**
         * Returns a list of flatten element, with depth indicator.
         * NOTE: we loose the hierarchy here because it is flat, but we  keep
         * the dept and the proper order.
         */
        function _buildItemFlatTree(tree, depth, items) {
            tree['item'].depth = depth;
            items.push(tree['item']);

            if (tree['children']) {
                depth++;
                angular.forEach(tree['children'], function(child) {
                    _buildItemFlatTree(child, depth, items);
                });
            }
        }

        function _loadReferentielItemsByType(item_id, item_type, fields, rootOnly) {
            _fetchItemRootTree(item_type, item_id, fields).then(function(root_item) {
                var collection = swif.collections.createCollection(`task-${item_type}`, item_type);

                if (!root_item) {
                    $scope.referentiel_items[item_type] = collection;
                    return;
                }

                function populateTree(tree) {
                    var items = [];
                    _buildItemFlatTree(tree, 0, items);
                    collection.replaceItems(items);
                    $scope.referentiel_items[item_type] = collection;

                    angular.forEach(items, function(item) {
                        $scope.model._referentiel_items.push(item);
                    });
                }

                var tree = {
                    'item': root_item,
                    'children': {},
                }

                if (rootOnly) {
                    populateTree(tree);
                } else {
                    _buildItemTree(root_item, tree['children'], fields).then(function() {
                        populateTree(tree);
                    });
                }
            });

        }

        function loadReferentielSite() {
            var state_options = [];
            angular.forEach(swif.settings.getContentType('site').states, function(state, state_id) {
                state_options.push({
                    id: state_id,
                    name: gettextCatalog.getString(state.title),
                });
            });
            $scope.state_options['site'] = state_options;

            var fields = [
                "name", "state", "description", "actions", "active",
                "site_parent_id", "service_ids",
            ];
            var item_id = $scope.model.site1[0];
            var item_type = 'site';

            _loadReferentielItemsByType(item_id, item_type, fields, true);
        }

        function loadReferentielEquipments() {
            $scope.state_options['equipment'] = openbase.equipment.getStatesConfig();

            var fields = [
                "name", "state", "description", "actions", "active",
                "parent_id", "maintenance_service_ids", "categ_id", "qty_available",
                "site_id", "date_start", "life_duration",
            ];
            var item_id = $scope.model.equipment_id[0];
            var item_type = 'equipment';

            _loadReferentielItemsByType(item_id, item_type, fields);
        }

        $scope.loadReferentielItems = function() {
            // Load sites (in fact only one for now)
            if ($scope.model.site1) {  // May happen?
                loadReferentielSite();
            }

            // Load equipments (including children)
            if ($scope.model.equipment_id) {  // Sure it could happen!
                loadReferentielEquipments();
            }
        }

        function getPurchaseOrdersByConsumableIds(ids){
            swif.data.callKw(
                'consumable',
                'get_purchase_orders_by_consumable_ids',
                [[]],
                {user_service_ids: $scope.user.service_ids, context: {}}
            ).then(function(consumables){
                swifOpenbaseCompanyService.getCurrencySymbol().then(function(symbol){
                    _.forEach(consumables, function(consumable, id){
                        if('moves' in consumable && consumable['moves'].length > 0){
                            _.forEach(consumable['moves'], function(move){
                                $scope.consumable_choices.push({
                                    id: parseInt(id, 10),
                                    name: consumable.name,
                                    is_stock: consumable.is_stock,
                                    new: false,
                                    product_id: consumable.product_id || [],
                                    default_code: consumable.default_code,
                                    purchase_order: move.purchase_order,
                                    warehouse_id: move.purchase_order ? move.purchase_order.warehouse_id : [],
                                    supplier_id: move.purchase_order ? move.purchase_order.supplier_id : [],
                                    quantity: move.qty,
                                    quantity_left: move.qty_left,
                                    price: move.price_unit,
                                    symbol: symbol,
                                    default_warehouse_id: consumable.default_warehouse,
                                });
                            });
                        }else{
                            $scope.consumable_choices.push({
                                id: parseInt(id, 10),
                                name: consumable.name,
                                new: false,
                                is_stock: consumable.is_stock,
                                product_id: consumable.product_id || [],
                                price: consumable.price,
                                default_code: consumable.default_code,
                                default_warehouse_id: consumable.default_warehouse
                            });
                        }

                    });
                });

            });
        }

        $scope.onChangeProject = onChangeProject;
        $scope.onChangeProject();
        $scope.showMore = function (item) {
            item._showMore = !item._showMore;
        };
        $scope.copyConsumable = function (consumable) {
            $scope.model.consumables.push(angular.copy(consumable));
        };

        $scope.formatName = function(item){
            var item_name = false;

            var fa_class = item.is_stock ? 'fa-industry' : 'fa-shopping-cart';
            item_name = "<i class='fa "+ fa_class +"' aria-hidden='true'></i> ";

            if(item.is_stock && item.purchase_order && item.quantity && item.quantity_left){
                item_name += item.name + " ( BC N°"+ item.purchase_order.name+", Qté restante: "+ item.quantity_left + " sur "+ item.quantity+", P.U: "+ item.price+ item.symbol +" )";
            }else{
                item_name += item.name;
            }

            return $sce.trustAsHtml(item_name);
        };

        $scope.deleteConsumable = function (consumable) {
            var index = $scope.model.consumables.indexOf(consumable);
            if (index !== -1) {
                $scope.model.consumables.splice(index, 1);
            }
        };
        $scope.erase_name = function () {
            $scope.model.name = '';
        };
        $scope.onVehiculeChange = function (equipment) {
            $scope.model.km = equipment.km;
        };

        $scope.initRecurrence = function() {
            if ($scope.action.id === 'edit' && $scope.model.recurrence_id){
                //user wants to edit an existing recurrence
                swif.data.get('openstc_task_recurrence', $scope.model.recurrence_id[0]).then(function(result) {
                    $scope.model._recurrence = result;
                });
            }else{
                //user add a new recurrence
                if (!$scope.model._recurrence){
                    $scope.model._recurrence = {};
                    if($scope.model.date_start._isAMomentObject){
                        //planning give us a local time (BE need utc)
                        $scope.model.date_start = moment.utc($scope.model.date_start).format('YYYY-MM-DD HH:mm:ss');
                    }
                    // to launch the swif-widget-recurrence init
                    $scope.model._recurrence.date_start = $scope.model.date_start;
                }
            }
        };

        function sanitizeRecurrenceData(format_occurrence, recurrence) {
            // be careful here, we play with data, it's not the best way,
            // but we want to use swifRecurrenceService.getDates and save some bandwith
            delete format_occurrence.occurrences;
            format_occurrence._type = 'task';
            recurrence._type = 'openstc_task_recurrence';
            if ($scope.action.id === 'edit') {
                // we don't need this, and back-end send it back in each task...
                delete format_occurrence.occurrence_ids;
                delete format_occurrence.previous_task;
                delete format_occurrence.next_task;
                delete format_occurrence.id;
                delete format_occurrence.swif_id;
                delete format_occurrence.create_date;
                delete format_occurrence.recurrence;
                if ($scope.model.recurrence.recurrenceChoice == 'whole') {
                    //we have to change the date_start
                    recurrence.date_start = $scope.model._recurrence.date_start;
                    format_occurrence.date_start = $scope.model._recurrence.date_start;
                } else if ($scope.model.recurrence.recurrenceChoice == 'fromThisTask') {
                    recurrence.date_start = $scope.model.date_start;
                }
            }
        }

        $scope.generateDates = function(recurrence) {
            swif.message.loading($scope.loading.tasks);
            var format_occurrence = angular.copy(recurrence);
            sanitizeRecurrenceData(format_occurrence, recurrence);
            return swifRecurrenceService.getDates(recurrence, format_occurrence)
                .then(function(data) {
                    // We don't need to repeat in each date the recurrenceData
                    // so we send an array of dates and one recurrenceData
                    let recurrenceData = data[0];
                    if (recurrenceData.recur_length_type==='count'){
                        delete recurrenceData.date_end;
                    }
                    if (!$scope.model.recurrence){
                        $scope.model.recurrence = {};
                    }
                    $scope.model.recurrence.recurrence = recurrenceData;
                    $scope.model.recurrence.dates = _.pluck(data, 'date_start');
                    swif.message.loading($scope.loading.tasks, 'ok');
                }, function() {
                    swif.message.loading($scope.loading.tasks, 'ko');
                });
        };

        $scope.removeDate = function(date) {
            _.remove($scope.model.recurrence.dates, function (item) {
                return item === date;
            });
        };

        $scope.onChangeConsumable = onChangeConsumable;
        $scope.onChangePurchaseOrder = onChangePurchaseOrder;

        if ($scope.model.state === 'absent') {
             $scope.model.project_id = false;
            $scope.model.remaining_hours = 0;
            if ($scope.model.user_id) {
                swif.data.get('user', $scope.model.user_id[0]).then(function (user) {
                    $scope.currentUser = user;
                    var authenticated_user = swif.user.getAuthenticatedUserData();
                    var service_ids = _.intersection(user.service_ids, authenticated_user.service_ids);
                    if (!_.isEmpty(service_ids)) {
                        $scope.model.service_id = [service_ids[0], 'Service'];
                    }
                });
            } else if ($scope.model.team_id) {
                swif.data.get('team', $scope.model.team_id[0]).then(function (team) {
                    $scope.currentTeam = team;
                });
            } else if ($scope.model.partner_id) {
                swif.data.get('partner', $scope.model.partner_id[0]).then(function (partner) {
                    $scope.currentSupplier = partner;
                });
            }
        }

        $scope.$watchGroup([
            'model.user_id',
            'state.advanced_mode',
            'model.team_id',
            'model.partner_id',
            'model.partner_address',
            'model.service_id'
        ], watchAssigned);
        $scope.$watch('model._useATasksRange', watchUseATaskRange);
        $scope.$watch('model.consumables.length', watchConsumables);
        $scope.$watch('state.done', watchStateDone);
        $scope.$watch('model.project_id', watchProjectId);
        $scope.$watch('model.project_id', watchProjectIdBis);
        $scope.$watch('model.category_id', watchCategoryId);
        $scope.$watch('model.absent_type_id', watchAbsentTypeId);
        $scope.$watch('model.date_start', watchDateStart);
        $scope.$watch('model.date_end', watchDateEnd);
        $scope.$watch('model.planned_hours', watchPlannedHours);
        $scope.$watch('model._templates', watchTasksTemplates, true);

        if(modules.openstc_achat_stock){
            $scope.getPurchaseOrdersByConsumableIds = getPurchaseOrdersByConsumableIds;
            $scope.getPurchaseOrdersByConsumableIds();
        }
        if ($scope.model.state !== 'absent') {
            $scope.$watchGroup([
                'model.date_start',
                'model.planned_hours',
                'model.report_hours'
            ], function () {
                updatDateEndFromStartPlusDuration();
            });
        }
        function updateFilters() {
            $scope.filters = moduleInter.task.getFilters(
                $scope.model, $scope.currentIntervention, $scope.state.advanced_mode
            );
        }

        function _updateNewAgentFilter () {
            let ids = $scope.model._tasks.map((t) => {
                return t.user_id[0];
            });
            swif.data.addFilter($scope.filters.newagent, 'id', '!=', ids);
        }

        var reportHoursWatcher;
        function toggleSplitTeam() {
            $scope.team_splited = !$scope.team_splited;
            if ($scope.team_splited) {
                // get the team members
                // create one task per member
                let team_id = $scope.model.team_id[0];
                swif.data.get('team', team_id, {fields: ['user_names']})
                .then(function (team) {
                    $scope.model._tasks = team.user_names.map((username) => {
                        return {
                            user_id:  angular.copy(username),
                            report_hours: $scope.model.report_hours,
                            date_start: $scope.model.date_start,
                            planned_hours: $scope.model.planned_hours
                        };
                    });
                    _updateNewAgentFilter();
                });
                // Watch first agent report hours to set correct date end
                reportHoursWatcher = $scope.$watch('model._tasks[0].report_hours', watchFirstAgentReportHours);

            } else if ($scope.team_splited) {
                $scope.model._tasks = []; // Delete tasks
                reportHoursWatcher(); // Destroy watcher
            }
        }

        function addNewAgent(newAgent) {
            if ($scope.model._tasks && newAgent) {
                $scope.model._tasks.push({
                    user_id: [newAgent.id, newAgent.name],
                    report_hours: $scope.model.report_hours,
                    date_start:  $scope.model.date_start,
                    planned_hours: $scope.model.planned_hours
                });
            }
            $scope.addNewAgentModel.newAgent = false;
            _updateNewAgentFilter();
        }

        var askedConsumableMustLoad = true;
        function loadAskedConsumables() {
            $scope.resizeModal('down');
            if ($scope.model.consumable_asks && $scope.model.consumable_asks.length && askedConsumableMustLoad) {
                let productsIds = [];
                angular.forEach($scope.model.consumable_asks, (consumable) => {
                    productsIds.push(consumable.product_id[0]);
                });

                // Get consumables from their id
                let filter = {};
                swif.data.addFilter(filter, 'product_id', 'in', productsIds);
                swif.data.searchRead('consumable', filter).then(function (consumables) {
                    if (!_.isEmpty(consumables)) {
                        angular.forEach(consumables.records, (consumable) => {
                            var index = _.findIndex($scope.model.consumable_asks, ask => ask.product_id[0] === consumable.product_id[0]);
                            consumable.qty_remaining = $scope.model.consumable_asks[index].qty_remaining;
                            consumable.quantity = $scope.model.consumable_asks[index].product_qty;
                            consumable.isAskedConsumable = true;
                            consumable.consumable_swif_id = $scope.model.consumable_swif_id;
                            onChangeConsumable(consumable);
                        })
                    }
                });
                askedConsumableMustLoad = false
            }
        }

        function referentialChecked() {
            $scope.resizeModal('up');
            if ($scope.action.hiddenTitle) {
                $scope.action.title = $scope.action.hiddenTitle;
            }
            $scope.form.$waitAction = false;
        }

        function setCurrentTr(task) {
            $scope.model._tasks.forEach(function (t) {
                t._isCurrent = t._isCurrent === true ? false : t === task;
            });
        }

        function setCurrentTmpl(tmpl) {
            $scope.model._templates.forEach(function (t) {
                t._isCurrent = t._isCurrent === true ? false : t._id === tmpl._id;
            });
        }

        function deleteTask(task) {
            $scope.model._tasks.splice($scope.model._tasks.indexOf(task), 1);
            $scope.filters.newagent = {};
            _updateNewAgentFilter();
        }

        $scope.loadingTasksRange = false;
        $scope.noTasksTemplatesInCollection = false;
        function addTasksFromRange(taskRange) {
            $scope.form.$setValidity('tasks-range-valid', true);
            $scope.noTasksTemplatesInCollection = false;
            if (taskRange.id) {
                $scope.model._templates = [];

                $scope.loadingTasksRange = true;
                var filter = {};
                swif.data.addFilter(filter, 'task_range_id', '=', taskRange.id);
                swif.data.sortOn(filter, 'sequence', 'ASC');
                swif.collection.createOrUpdate(
                    'task_tasks_templates',
                    'task_template',
                    filter
                ).then(collection => {
                    if (collection.items.length) {
                        collection.items.map(taskTemplate => {
                            $scope.model._templates.push({
                                _id: taskTemplate.id,
                                name: taskTemplate.name,
                                category_id: taskTemplate.category_id[0],
                                user_id: taskTemplate.user_id,
                                team_id: taskTemplate.team_id,
                                partner_id: taskTemplate.partner_id,
                                partner_address: taskTemplate.partner_address,
                                notify: taskTemplate.notify,
                                planned_hours: taskTemplate.planned_hours,
                                report_hours: taskTemplate.planned_hours,
                                description: taskTemplate.description,
                                site1: $scope.model.site1[0],
                                service_id: $scope.model.service_id[0],
                                project_id: $scope.model.project_id[0],
                                date_start: $scope.model.date_start,
                                _isCurrent: false
                            });
                        });
                    } else {
                        $scope.noTasksTemplatesInCollection = true;

                        // Invalidate form
                        $scope.form.$setValidity('tasks-range-valid', false);
                    }
                });
                $scope.loadingTasksRange = false;
            } else {
                delete $scope.model._templates;
            }
        }

        function moveTemplate(tmplId, direction) {
            var templates = $scope.model._templates;
            var newIndex;
            var index = templates.findIndex(t => t._id == tmplId);
            if (direction === 'up') {
                newIndex = index - 1;
            } else if (direction === 'down') {
                newIndex = index + 1;
            }
            var tmplToMove = _.remove(templates, t => t._id == tmplId);
            templates.splice(newIndex, 0, tmplToMove[0]);
        }

        function removeTemplate(index) {
            $scope.model._templates.splice(index, 1);
        }

        function samePeopleForNext(tmpl, index) {
            let tmpls = $scope.model._templates;
            for (let i = index+1 ; i < tmpls.length ; i++) {
                tmpls[i].user_id = tmpl.user_id;
                tmpls[i].team_id = tmpl.team_id;
                tmpls[i].partner_id = tmpl.partner_id;
                tmpls[i].partner_address = tmpl.partner_address;
            }
        }

        function sameDateForNext(date_start, index) {
            let tmpls = $scope.model._templates;
            for (let i = index+1 ; i < tmpls.length ; i++) {
                tmpls[i].date_start = date_start;
            }
        }

        $scope.calculateSuccess = false;
        $scope.calculateErrorAtPeople = false;
        $scope.calculateErrorAtDates = false;
        function calculateRangeHours() {
            $scope.calculateErrorAtPeople = false;
            $scope.calculateErrorAtDates = false;
            let valid = true;
            for (let tmpl of $scope.model._templates) {
                if (tmpl.user_id == false &&
                    tmpl.team_id == false &&
                    tmpl.partner_id == false) {
                    $scope.calculateErrorAtPeople = true;
                    valid = false;
                    break;
                }
            }
            if (valid) {
                let prev = undefined;
                for (let i=0 ; i < $scope.model._templates.length ; i++) {
                    let t = $scope.model._templates[i];
                    if (prev != undefined) {
                        if ((prev.user_id != false && t.user_id != false && t.user_id[0] === prev.user_id[0]) ||
                            (prev.team_id != false && t.team_id != false && t.team_id[0] === prev.team_id[0]) ||
                            (prev.partner_id != false && t.partner_id != false && t.partner_id[0] === prev.partner_id[0])
                        ) {
                            if (prev.date_start === false) {
                                $scope.calculateErrorAtDates = true;
                                return;
                            }
                            t.date_start = moment(prev.date_start).add(prev.report_hours, 'h').format('YYYY-MM-DD HH:mm:ss');
                        }
                    }
                    prev = t;
                }
                $scope.calculateSuccess = true;
                $timeout(function() {
                    $scope.calculateSuccess = false;
                }, 1500)
            }
        }

        function onChangeProject () {
            var filter = {};
            filter.fields = moduleInter.task.PROJECT_ID_FIELDS;
            if ($scope.model.project_id && $scope.model.can_read_project) {
                swif.data.get('intervention', $scope.model.project_id[0], filter)
                .then(function (currentIntervention) {
                    $scope.currentIntervention = currentIntervention;
                    $scope.project_type = moduleInter.intervention.getProjectType(currentIntervention);
                    updateFilters();
                    if ($scope.model && currentIntervention.service_id) {
                        if (!$scope.model.service_id) {
                            $scope.model.service_id = angular.copy(currentIntervention.service_id);
                        }
                    }
                });
            } else {
                $scope.project_type = moduleInter.intervention.getProjectType(swif.$location.search().project_type);

                if ($scope.model.project_id) {
                    $scope.currentIntervention = {
                        id: $scope.model.project_id[0],
                        name: $scope.model.project_id[1]
                    };
                }
            }
        }

        function onChangePurchaseOrder (purchase_order) {
            if (purchase_order.id) {
                var consumables_formatted = {
                    'lines': {}
                };

                // Add in task done furnitures all consumables ordered from the selected purchase order

                swif.data.get('purchase_order', purchase_order.id, {}).then(function(currentPurchaseOrder){

                    var stockFilter = {};
                    var order_line_ids = currentPurchaseOrder['order_line'];

                    swif.data.addFilter(stockFilter, 'purchase_line_id', 'in', order_line_ids);
                    return swif.data.get('stock_move', undefined, stockFilter).then(function (stock_moves) {

                        stock_moves.forEach(function(stock_move){

                            var product_id = stock_move['product_id'];
                            var quantity = stock_move['product_qty'];
                            var price = stock_move['price_unit'];

                            consumables_formatted['lines'][product_id[0]] = {
                                'quantity': quantity,
                                'price': price,
                                'purchase_order': purchase_order,
                                'product_id': product_id,
                                'warehouse_id': currentPurchaseOrder.warehouse_id,
                                'supplier_id': currentPurchaseOrder.partner_id
                            };
                        });

                        return consumables_formatted;
                    });
                }).then(function(consumables_formatted){

                    var conFilter = {};
                    var product_ids = Object.keys(consumables_formatted['lines']).map(function (x) {
                        return parseInt(x, 10);
                    });

                    swif.data.addFilter(conFilter, 'product_id', 'in', product_ids);
                    swif.data.get('consumable', undefined, conFilter).then(function (consumables){
                        consumables.forEach(function(consumable){

                            var product_id = consumable.product_id[0];

                            consumables_formatted['lines'][product_id]['id'] = consumable.id;
                            consumables_formatted['lines'][product_id]['name'] = consumable.name;
                            consumables_formatted['lines'][product_id]['is_stock'] = consumable.is_stock;

                        });

                        for(var line in consumables_formatted['lines']){
                            onChangeConsumable(consumables_formatted['lines'][line]);
                        }
                    });
                });
            }
        }

        function updatDateEndFromStartPlusDuration() {
            moduleInter.task.syncDateEnd($scope.model);
        }

        function updateTaskFilters() {
            $scope.filters = moduleInter.task.getFilters(
                $scope.model, $scope.currentIntervention, $scope.state.advanced_mode
            );
            if ($scope.isUserPartner){
                // Add servce filter to show only authorized service for current partner user
                swif.user.getPartner(['technical_service_ids']).then(function (partner) {
                    if (partner && !_.isEmpty(partner.technical_service_ids)) {
                        swif.data.addFilter(
                            $scope.filters.department,
                            'id', 'in', partner.technical_service_ids
                        );
                    }
                });
            }
        }

        function onCustomerPartnerAddressChange (customer_partner_address) {
            if (customer_partner_address) {
                if (customer_partner_address.partner_id && !$scope.model.customer_partner_id) {
                    $scope.model.customer_partner_id = customer_partner_address.partner_id;
                }
            }
        }

        function onCustomerPartnerChange (newV) {
            updateFilters();
        }

        function deleteCustomer () {
            $scope.model.customer_partner_address = false;
            $scope.model.customer_partner_id = false;
            updateFilters();
        }

        function watchAssigned(newV) {
            updateTaskFilters();
            if (newV[0]) {
                if ($scope.equipmentMovementFeature) {
                    moduleInter.task.updateUserPartnerAddressFromUser($scope.model, newV[0][0]);
                }
                moduleInter.task.updateServiceFromUser($scope.model, newV[0][0]);
            }
        }

        function watchProjectId(newV) {
            if (newV) {
                if ($scope.currentIntervention) {
                    if (newV[0] === $scope.currentIntervention.id) {
                        return;
                    }
                }
                onChangeProject();
            }
        }

        function watchConsumables(newV) {
            if (newV > 0) {
                $('.modal-dialog').addClass('modal-large');
            } else {
                $('.modal-dialog').removeClass('modal-large');
            }
        }
        function onChangeConsumable(consumable, isDisabled) {
            if ($scope.model.consumables === undefined || $scope.model.consumables === false) {
                $scope.model.consumables = [];
            }

            if ($scope.task_purchase_order_default_value) {
                var quantity = consumable.quantity_left || consumable.quantity || 1;
            } else {
                var quantity = 1;
            }

            var consumable_to_add = {
                consumable_id: [consumable.id, consumable.name],
                dqe: '',
                // We want to show warehouse select input only if the consumable is addedManuallyByUser
                addedManuallyByUser: consumable.isAskedConsumable ? false : true,
                quantity: quantity,
                product_id: consumable.product_id[0],
                isAskedConsumable: consumable.isAskedConsumable || false,
                consumable_swif_id: consumable.consumable_swif_id || false,
                stocked: consumable.is_stock,
                user_warehouse_ids: $scope.user.warehouse_ids,
                unit_price: consumable.price,
                supplier_id: consumable.supplier_id || false,
                purchase_order_name: consumable.purchase_order ? consumable.purchase_order.name : '',
                warehouse_id: consumable.warehouse_id || 0,
                qty_remaining: !_.isUndefined(consumable.qty_remaining) && consumable.qty_remaining !== false ? consumable.qty_remaining : false
            };

            let user_warehouse_value = function(warehouses){
                if($scope.user.warehouse_ids.length === 1){
                    // if user has only one warehouse we ger it  from the list of objects warehouses that contains the user
                    // warehouse and the default consumable warehouse
                    return warehouses.filter(w => w.id === $scope.user.warehouse_ids[0]);
                } else if ($scope.user.warehouse_ids.length > 1 && !_.isEmpty(consumable.default_warehouse_id)){
                    //displaying the consumable default warehouse if user manage multiple warehouses
                    return warehouses.filter(w => w.id === consumable.default_warehouse_id[0]);
                }
            }

            // If the user can have access to warehouses
            if (!_.isEmpty($scope.user.warehouse_ids) && !consumable_to_add.isAskedConsumable) {
                $scope.filterWarehouse = {fields: ['id', 'complete_name', 'name']};
                swif.data.addFilter(
                    $scope.filterWarehouse,
                    'id', 'in', _.uniq($scope.user.warehouse_ids.concat(consumable.default_warehouse_id ? [consumable.default_warehouse_id[0]] : []))
                );
                swif.data.get('stock_warehouse', undefined, $scope.filterWarehouse).then(function (warehouses) {
                    consumable_to_add['user_warehouse_ids'] = warehouses
                    if($scope.user.warehouse_ids > 0){
                        // call  user_warehouse_value  function
                        let user_warehouse = user_warehouse_value(warehouses)
                        consumable_to_add['warehouse_id'] = [user_warehouse[0].id, user_warehouse[0].complete_name]
                    } else {
                        consumable_to_add['warehouse_id'] = [warehouses[0].id, warehouses[0].complete_name];
                    }
                })
            } else if ((_.isEmpty($scope.user.warehouse_ids) && consumable.is_stock) || (consumable_to_add.isAskedConsumable && consumable.is_stock)) {
                // Search warehouse_id of the product
                var productFilter = {};
                swif.data.addFilter(productFilter, 'product_id', '=',consumable.product_id[0]);
                swif.data.get('stock_move', undefined, productFilter).then(function (stock_moves) {
                    stock_moves.forEach(function(stock_move){
                        consumable_to_add['warehouse_id'] = stock_move.warehouse_id;
                    });
                });
            }

            $scope.selected = {};

            // Add product to consumables list or increase quantity of existing
            var consumableIndex = _.findIndex($scope.model.consumables, function (consu) {
                return consu.consumable_id[0] === consumable_to_add.consumable_id[0] && !consu.consumable_swif_id;
            });
            // Don't increase the quantity if the consumable is an asked consumable
            var askedConsumableIndex = _.findIndex($scope.model.consumables, function (consu) {
                return consu.consumable_id[0] === consumable_to_add.consumable_id[0] && consu.consumable_swif_id;
            });

            if(consumable_to_add.isAskedConsumable) {
                $scope.model.consumables.push(consumable_to_add);
            } else {
                if(consumableIndex != -1) {
                    $scope.model.consumables[consumableIndex].quantity += 1;
                } else if(askedConsumableIndex != -1) {
                    $scope.model.consumables.push(consumable_to_add);
                } else {
                    $scope.model.consumables.push(consumable_to_add);
                }
            }
        }

        function watchStateDone(newV, oldV) {
            if (newV === undefined || newV === oldV) {
                return;
            }

            moduleInter.task.changeDoneState($scope.model, newV);
            if (newV) {
                $scope.model.consumable_asks = [];
            }
        }

        function watchProjectIdBis(newV, oldV) {
            if ($scope.model === undefined) {
                return;
            }
            if (oldV) {
                if (oldV[1] === $scope.model.name) {
                    $scope.erase_name();
                    if ($scope.currentIntervention && !$scope.model.can_read_project) {
                        // Don't leave name empty if task have intervention but no right to select it
                        $scope.model.name = $scope.currentIntervention.name;
                    }
                }
            }
            if (newV && _.isEmpty($scope.model.name)) {
                $scope.model.name = newV[1];
            }
        }

        function watchCategoryId(newV, oldV) {
            if ($scope.model === undefined) {
                return;
            }
            var newVal = newV ? newV[1] : '';
            var oldVal = oldV ? oldV[1] : '';
            var newString = $scope.model.name;
            if(!$scope.model.name && newVal) {
                newString = newVal;
            }else if(!angular.equals(newVal, oldVal) && oldVal === $scope.model.name) {
                newString = newVal;
            }
            $scope.model.name = newString;
        }

        function watchAbsentTypeId(newV) {
            if (newV) {
                $scope.model.name = newV[1];
            }
        }

        function watchDateStart(newV) {
            if ($scope.model.state === 'absent' && newV) {
                var de = moment.utc($scope.model.date_end);
                var m;
                if (_.isString(newV)) {
                    m = moment.utc(newV);
                } else {
                    m = newV.utc();
                }
                if (de) {
                    $scope.model.planned_hours = moment.duration(de.diff(m)).asHours();
                }
            }
            if (!$scope.model.consumable_ask_date_delivery) {
                $scope.model.consumable_ask_date_delivery = newV;
            }
        }

        function watchDateEnd(newV) {
            if ($scope.model.state === 'absent' && newV) {
                var ds = moment.utc($scope.model.date_start);
                var m;
                if (_.isString(newV)) {
                    m = moment.utc(newV);
                } else {
                    m = newV.utc();
                }
                if (ds) {
                    $scope.model.planned_hours = moment.duration(m.diff(ds)).asHours();
                }
            }
        }

        function watchPlannedHours(newV) {
            if ($scope.model.state === 'absent' && newV) {
                $scope.model.effective_hours = newV;
            }
        }

        function watchFirstAgentReportHours(newV) {
            $scope.model.date_end = moment($scope.model.date_start, 'YYYY-MM-DD HH:mm:ss').add(newV, 'h').format('YYYY-MM-DD HH:mm:ss');
        }

        function watchUseATaskRange(newV) {
            if (newV) {
                $('.modal-dialog').addClass('modal-lg');
                if (_.isUndefined($scope.model._templates)) {
                    $scope.model._templates = [];
                }
            } else {
                delete $scope.model._templates;
                $('.modal-dialog').removeClass('modal-lg');
            }
        }

        function watchTasksTemplates(newV) {
            if (!_.isUndefined(newV)) {
                let isValid = true;
                for (let tmpl of newV) {
                    if ((tmpl.user_id === false && tmpl.team_id === false && tmpl.partner_id === false) || tmpl.date_start === false ) {
                        isValid = false;
                        break;
                    }
                }
                $scope.form.$setValidity('tasks-range-valid', isValid);
            }
        }
    }


    function TaskDetailsModalController($scope, $uibModalInstance, modalParams, swif, swifRouteService, swifCartoLeafletService, swifOpenbaseKeysService) {
        'ngInject';

        $scope.model = modalParams.model;
        const user = swif.user.getAuthenticatedUserData();
        const isManager = (_.includes(user.access_rights, 'MANA') || _.includes(user.access_rights, 'ELU'));
        $scope.extra = '';
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        const cartoService = swifCartoLeafletService;
        $scope.setExtra = function(view) {
            if (view === 'map') {
                swifRouteService.check({resources: ['leaflet']}).then(function () {
                    $scope.extra = view;
                });
            } else {
                $scope.extra = view;
            }
        }

        // Watch model attachments loading
        $scope.$watch('model._attachments', function (newV, oldV) {
            $scope.attachments = newV;
        });
        $scope.$watch('model._attachments_img', function (newV, oldV) {
            $scope.images = newV;
        });

        // Get keys
        if (isManager) {
            let keysFilter = {};
            swif.data.addFilter(keysFilter, 'site_ids', 'in', [$scope.model.site1[0]])
            swif.data.get('key', undefined, keysFilter).then(function (keys) {
                $scope.keys = keys;
            });
        }

        // Init map
        $scope.onMapInitialized = function (map) {
            $scope.map = map;

            if ($scope.model.osm_zoom) {
                $scope.map.setZoom($scope.model.osm_zoom);
            }
            if ($scope.model.geo_point) {
                 // Display site polygon, parents polygons and task geo_point
                cartoService.getParentSiteWithPolygon($scope.model.site.id).then(parentSites => {
                    // Add current site to his parents
                    var sites = parentSites.concat([$scope.model.site]);

                    var polygons = cartoService.setChildAndParentsPolygons(sites);
                    var layer = L.featureGroup(polygons);
                    layer.addTo($scope.map);

                    let marker = cartoService.getMarkerFromPoint($scope.model.geo_point);
                    if (marker) {
                        marker.addTo(layer);
                        $scope.map.setView(marker.getLatLng());
                    }
                    if (!$scope.model.geo_point && !_.isEmpty(polygons)) {
                        // We want to center the map to the current site (the last item)
                        var bounds = _.last(polygons).getBounds();
                        $scope.map.fitBounds(bounds);
                    }
                });
            }
        };

        // Get site data
        $scope.siteFilter = {fields: [
                'name', 'type_id', 'site_parent_id', 'surface', 'code',
                'lat', 'long', 'street', 'street2', 'zip', 'city', 'geo_polygon',
            ]};
        swif.data.get('site', $scope.model.site1[0], $scope.siteFilter).then(function(data){
            $scope.model.site = data;

            // Init extra view
            if ($scope.extra === '' && $scope.model.geo_point) {
                $scope.setExtra('map');
            }
        });

        swif.data.callKw('task', 'get_linked_intervention', [$scope.model.project_id[0]]).then(function (intervention) {
                $scope.model.intervention_assignement_id = intervention.intervention_assignement_id;
                $scope.model.inter_desc = intervention.description;
        })

        // Manage consumable ask state
        var ask_prod_state = $scope.model.consumable_request_state;
        if (ask_prod_state) {
            $scope.askProdState = swif.settings.getContentType('openstc_ask_prod').states[ask_prod_state];
            $scope.askProdLabelclass = `label-${$scope.askProdState.labelclass}`;
        }

    }

})();
